import React from "react";
import * as s from "./DocumentHighlight.module.scss";
import { BackgroundImage, P, DynamicLink } from "src/views/shared/components";
import { stripHtmlFromString, truncate } from "src/libs/utils";
import { ISingleWordpressDocument } from "src/models";
import { UIStore } from "src/stores";
import { inject, observer } from "mobx-react";
import { fallbackImage } from "src/libs/utils/fallbacks";
import { tx } from "src/libs/i18n";

interface Props {
  uiStore?: UIStore;
  document: ISingleWordpressDocument;
  bordered?: boolean;
  padding?: boolean;
}
@inject("uiStore")
@observer
export class DocumentHighlight extends React.Component<Props> {
  render() {
    const { document, bordered, padding } = this.props;
    if (!document) return <></>;
    const {
      link,
      title,
      documentThumbnail,
      documentFields,
      documentPublishers
    } = document;
    const { publishers } = documentPublishers || {};
    const { image } = documentThumbnail || {};
    const { abstract, publicationYear } = documentFields || {};

    let documentHighlightClasses = [s.documentHighlight];
    let documentContentClasses = [s.documentHighlight];

    if (bordered) {
      documentHighlightClasses.push(s.bordered);
    }

    if (padding) {
      documentContentClasses.push(s.padding);
    } else {
      documentContentClasses.push(s.noPadding);
    }
    let abstractLength = padding && !this.props.uiStore.isDesktop ? 80 : 180;
    let strippedAbstract = stripHtmlFromString(abstract);

    return (
      <div className={documentHighlightClasses.join(" ")}>
        <div className={documentContentClasses.join(" ")}>
          <DynamicLink to={link} className={s.documentImage}>
            <BackgroundImage image={image || fallbackImage("document")} />
          </DynamicLink>
          <div className={s.documentInformation}>
            <DynamicLink to={link} className={s.title}>
              <h6>{title}</h6>
            </DynamicLink>
            <P small className={s.publishingInformationLabel}>
              {publicationYear}
              {publicationYear && publishers?.[0] && " · "}
              {publishers?.[0]?.name}
            </P>
            <P className={s.abstract}>
              {truncate(strippedAbstract, abstractLength)}
              {strippedAbstract?.length > abstractLength && (
                <DynamicLink to={link} className={s.viewFullAbstractLink}>
                  {tx("document.viewAbstract")}
                </DynamicLink>
              )}
            </P>
          </div>
        </div>
      </div>
    );
  }
}
